<template>
  <div class="flex flex-col">
    <div
      class="text-static-default-hi body-2 flex"
      :class="discountedPrice ? 'flex-col-reverse' : 'flex-col'"
      data-qa="productCardPrice"
    >
      <div v-if="discountedPrice" class="body-2-bold">
        {{ discountedPrice }}
        <span>
          {{ i18n(translations.afterBuyback) }}
        </span>
      </div>
      <div :class="{ 'body-2-bold': !discountedPrice }">
        {{ price }}
        <span v-if="discountedPrice">
          {{ i18n(translations.dueToday) }}
        </span>
      </div>
      <div v-if="priceNew" class="text-static-default-low line-through">
        {{ priceNew }}
        <span>
          {{ i18n(translations.newKeyword) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './ProductPrice.translations'

defineProps<{
  price: string
  priceNew?: string
  discountedPrice?: string
}>()

const i18n = useI18n()
</script>
